import Select from 'src/common/refactoredComponents/select/Select';
import React, { useRef } from 'react';
import { sizes } from 'src/styles/Media.styled';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { getDisplayDate } from 'src/utils/dateUtils';
import {
    FooterContainer,
    MultipleAllocations,
    BatchName,
} from 'src/pages/scheduleSurgery/components/shipping/BatchLocationCard.styled.jsx';
import {
    SelectedDiv,
    SelectedCurrentLoc,
    Parked,
} from 'src/pages/scheduleSurgery/components/shipping/NonTissueProductCard.styled';
import AlertCircleOutline from 'src/assets/images/AlertCircleOutline.svg';
import { FooterLabel } from 'src/pages/scheduleSurgery/components/shipping/BatchLocationCard.styled.jsx';
import NtCheckboxCheckedAndDisabled from '../../../pages/scheduleSurgery/components/shipping/NonTissuecomponents/NtCheckboxCheckedAndDisabled';
import NtCheckboxwithTransferFailedWithDropdown from '../../../pages/scheduleSurgery/components/shipping/NonTissuecomponents/NtCheckboxwithTransferFailedWithDropdown';
import NtCheckboxDropdownWithErroText from '../../../pages/scheduleSurgery/components/shipping/NonTissuecomponents/NtCheckboxDropdownWithErroText';

import BatchLocationCard from 'src/pages/scheduleSurgery/components/shipping/BatchLocationCard';
import { RedCircle } from 'src/pages/scheduleSurgery/components/shipping/BatchLocationCard.styled';
import {
    getShippingBatchAllocations,
    updateCartDataShipping,
    setSurgeryDetailsGeneric,
} from 'src/pages/scheduleSurgery/redux/actions';
import { getBrowserTimeZoneName } from 'src/utils/dateUtils';
import { convertTime24To12, isTransferSurgery, logErrorToConsole } from 'src/utils/util';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';
import { US_COUNTRY_CODE } from 'src/constants/appConstants';

const BatchDropDown = ({
    product,
    checkAll,
    checked,
    countryISOCode,
    selectedLocation,
    setReservationBatch,
    setIsBatchSelected,
    setAllocatedData,
    allocatedData,
    inventoryShipping,
    isShowCheckBox,
    isMessageDisplay,
    isShowLabelEmpty,
    isShowSetLocation,
    isShowDropDown,
}) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const winWidth = window.innerWidth;
    const isDesktopView = winWidth >= sizes.mediumDevice;
    const isMobileView = winWidth < sizes.smalDevice;
    const prevCheckedRef = useRef(checked);
    const isLastIndividualCheck = useSelector(
        (state) => state.surgeryReducer.isLastIndividualCheck
    );
    // Sync to a ref so changes to isLastIndividualCheck do not re-trigger the
    // allocation effect – prevents a redundant re-run when the flag is reset to
    // false inside that same effect.
    const isLastIndividualCheckRef = useRef(isLastIndividualCheck);
    isLastIndividualCheckRef.current = isLastIndividualCheck;
    let batchLocations = useSelector((state) =>
        state.shippingBatchAllocation.batchAllocations.find(
            (batch) =>
                batch.productCfn === (product?.cfn || product?.productCFN)
        )
    );

    const handleReservationBatch = (value) => {
        if (value) {
            const batchDetails = batchLocations.batchAllocations
                .filter((batch) =>
                    countryISOCode !== US_COUNTRY_CODE ? true : batch.isParked
                )
                .find((batch) => batch.id === value);
            const dispatchedObject = {
                batchCurrentLocation: batchDetails.currentLocation,
                batchId: batchDetails.id,
                batchParked: batchDetails.isParked ? true : false,
                shippingRequirement: true,
                batchAlreadyAllocated: batchDetails.batchAlreadyAllocated,
            };
            setIsBatchSelected(true);
            dispatchedObject.batchAlreadyAllocated
                ? setReservationBatch(
                      <FooterContainer
                          style={{ display: 'block', marginTop: '4px' }}
                          margin={'5px 0px 0px 7px'}
                          mbMargin={'10px 0px 0px 7px'}
                      >
                          <div style={{ display: 'flex', marginTop: '5px' }}>
                              <RedCircle style={{ marginTop: '3.5px' }}>
                                  !
                              </RedCircle>
                              <FooterLabel color="#ED002A">
                                  {t('equity.common.setsAndItems.allocated')}
                              </FooterLabel>
                          </div>

                          <div
                              style={{
                                  display: 'block',
                                  paddingLeft: '10px',
                              }}
                          >
                              {dispatchedObject.batchAlreadyAllocated?.map(
                                  (data, i) => {
                                      return (
                                          <React.Fragment key={i}>
                                              <MultipleAllocations
                                                  width={'93%'}
                                                  mbWidth={'285px'}
                                                  margin={'-2px'}
                                              >
                                                  <FooterLabel>
                                                      {getDisplayDate(
                                                          data.surgeryDate
                                                      )}
                                                  </FooterLabel>
                                                  <FooterLabel>
                                                      {convertTime24To12(
                                                          new Date(
                                                              data.surgeryDate
                                                          )
                                                      )}{' '}
                                                      (
                                                      {getBrowserTimeZoneName()}
                                                      )
                                                  </FooterLabel>
                                                  <FooterLabel>|</FooterLabel>
                                                  <BatchName>
                                                      <FooterLabel>
                                                          {data.accountName}
                                                      </FooterLabel>
                                                  </BatchName>
                                              </MultipleAllocations>
                                          </React.Fragment>
                                      );
                                  }
                              )}
                          </div>
                      </FooterContainer>
                  )
                : setReservationBatch(null);

            dispatch(
                updateCartDataShipping(
                    dispatchedObject,
                    [product.productKey],
                    true
                )
            );
        } else {
            dispatch(
                updateCartDataShipping(
                    {
                        batchCurrentLocation: null,
                        batchId: null,
                        batchParked: null,
                        shippingRequirement: true,
                        batchAlreadyAllocated: null,
                    },
                    [product.productKey],
                    true
                )
            );
            setReservationBatch(null);
        }
    };
    const handleLocationChange = (value) => {
        if (value) {
            const batchDetails = batchLocations.batchAllocations
                .filter((batch) =>
                    countryISOCode !== US_COUNTRY_CODE ? true : batch.isParked
                )
                .find((batch) => batch.id === value);
            const dispatchedObject = {
                batchCurrentLocation: batchDetails.currentLocation,
                batchId: batchDetails.id,
                batchParked: batchDetails.isParked ? true : false,
                shippingRequirement: false,
                batchAlreadyAllocated: batchDetails.batchAlreadyAllocated,
            };
            dispatchedObject.batchAlreadyAllocated
                ? setAllocatedData(
                      <FooterContainer
                          style={{ display: 'block', marginTop: '4px' }}
                          margin={'5px 0px 0px 7px'}
                          mbMargin={'10px 0px 0px 7px'}
                      >
                          <div style={{ display: 'flex', marginTop: '5px' }}>
                              <RedCircle style={{ marginTop: '3.5px' }}>
                                  !
                              </RedCircle>
                              <FooterLabel color="#ED002A">
                                  {t('equity.common.setsAndItems.allocated')}
                              </FooterLabel>
                          </div>

                          <div
                              style={{
                                  display: 'block',
                                  paddingLeft: '10px',
                              }}
                          >
                              {dispatchedObject.batchAlreadyAllocated?.map(
                                  (data, i) => {
                                      return (
                                          <React.Fragment key={i}>
                                              <MultipleAllocations
                                                  width={'93%'}
                                                  mbWidth={'285px'}
                                                  margin={'-2px'}
                                              >
                                                  <FooterLabel>
                                                      {getDisplayDate(
                                                          data.surgeryDate
                                                      )}
                                                  </FooterLabel>
                                                  <FooterLabel>
                                                      {convertTime24To12(
                                                          new Date(
                                                              data.surgeryDate
                                                          )
                                                      )}{' '}
                                                      (
                                                      {getBrowserTimeZoneName()}
                                                      )
                                                  </FooterLabel>
                                                  <FooterLabel>|</FooterLabel>
                                                  <BatchName>
                                                      <FooterLabel>
                                                          {data.accountName}
                                                      </FooterLabel>
                                                  </BatchName>
                                              </MultipleAllocations>
                                          </React.Fragment>
                                      );
                                  }
                              )}
                          </div>
                      </FooterContainer>
                  )
                : setAllocatedData(null);

            dispatch(
                updateCartDataShipping(
                    dispatchedObject,
                    [product.productKey],
                    false
                )
            );
        } else {
            dispatch(
                updateCartDataShipping(
                    {
                        batchCurrentLocation: null,
                        batchId: null,
                        batchParked: null,
                        shippingRequirement: false,
                        batchAlreadyAllocated: null,
                    },
                    [product.productKey],
                    false
                )
            );
            setAllocatedData(null);
        }
    };
    const batchLocationTemplate = (option) => {
        return (
                <BatchLocationCard
                    option={option}
                    isReservationSet={product?.isReservationSet}
                />
        );
    };
    const selectedBatchLocationTemplate = (option, props) => {
        if (option) {
            return option.id === 'Batch Not Found' ? (
                <SelectedDiv
                    width={product?.isReservationSet ? '261px' : isDesktopView ? '206px' : isMobileView && '284px'}
                >
                    <SelectedCurrentLoc
                        width={'auto'}
                        whiteSpace = {'normal  '}
                        overflowWrap = {'breakWord'}
                        wordWrap = {'breakWord'}
                    >
                        {t(
                            'scheduleSurgery.Shipping.ProductCard.batchNotFound'
                        )}
                    </SelectedCurrentLoc>
                </SelectedDiv>
            ) : (
                <SelectedDiv width={product?.isReservationSet  ? '261px' : isDesktopView ? '206px':isMobileView && '284px'}>
                    <SelectedCurrentLoc
                        width={'auto'}>  {option.currentLocationFormatted}
                    </SelectedCurrentLoc>
                    {option.isParked && !product?.isReservationSet && (
                        <Parked>
                            {t('equity.common.setsAndItems.parked')}
                        </Parked>
                    )}
                </SelectedDiv>
            );
        }

        return <span>{props.placeholder}</span>;
    };
    useEffectWithErrorLogging(() => {
        if (!product) return;

        const wasChecked = prevCheckedRef.current;
        // Only fetch allocations when the row checkbox is turned ON.
        // Never fetch on uncheck; also don't fetch due to header select-all toggles.
        const isTurningOn = !wasChecked && checked;

        // Update after computing transition so this ref remains a true "previous" value.
        prevCheckedRef.current = checked;
        if (!isTurningOn || (checkAll && !isLastIndividualCheckRef.current)) return;

        dispatch(
            getShippingBatchAllocations({
                cfn: [product?.cfn || product?.productCFN],
                isReservationSet: product?.isReservationSet,
            })
        );
        if (isLastIndividualCheckRef.current) {
            dispatch(setSurgeryDetailsGeneric({ name: 'isLastIndividualCheck', value: false }));
        }

    }, [checked, checkAll, isLastIndividualCheck]);
    return (
        <>
            {isTransferSurgery() &&
            product.status &&
            (countryISOCode === 'JP'
                ? product.status !== 'Not Allocated'
                : true) ? (
                <>
                    {product?.lineNumber != null ||
                    product?.lineNumber != undefined ? (
                        product?.batchAllocation?.id && !inventoryShipping ? (
                            batchLocations?.batchAllocations
                                ?.filter((batch) =>
                                    countryISOCode !== US_COUNTRY_CODE
                                        ? true
                                        : batch.isParked
                                )
                                .find(
                                    (batch) =>
                                        batch.id ===
                                        product?.batchAllocation?.id
                                ) ? (
                                <NtCheckboxCheckedAndDisabled
                                    label={t(
                                        'scheduleSurgery.Shipping.ProductCard.TransferComplete'
                                    )}
                                    batchLocations={batchLocations}
                                    productKey={product.productKey}
                                    nonTissueProduct={product}
                                    isShowCheckBox={isShowCheckBox}
                                    isMessageDisplay={isMessageDisplay}
                                    isShowLabelEmpty={isShowLabelEmpty}
                                    isShowSetLocation={isShowSetLocation}
                                />
                            ) : (
                                <NtCheckboxwithTransferFailedWithDropdown
                                    checkBoxClick={() => {
                                        try {
                                            if (!inventoryShipping)
                                                handleLocationChange(
                                                    product.productKey,
                                                    !product.shippingRequirement
                                                );
                                        } catch (error) {
                                            logErrorToConsole(error);
                                        }
                                    }}
                                    inventoryShipping={inventoryShipping}
                                    AlertCircleOutline={AlertCircleOutline}
                                    nonTissueProduct={product}
                                    batchLocations={batchLocations}
                                    selectedBatchLocationTemplate={
                                        selectedBatchLocationTemplate
                                    }
                                    checked={checked}
                                    batchLocationTemplate={
                                        batchLocationTemplate
                                    }
                                    selectedLocation={selectedLocation}
                                    handleLocationChange={handleLocationChange}
                                    isShowCheckBox={isShowCheckBox}
                                    isMessageDisplay={isMessageDisplay}
                                    isShowLabelEmpty={isShowLabelEmpty}
                                    isShowSetLocation={isShowSetLocation}
                                    isShowDropDown={isShowDropDown}
                                />
                            )
                        ) : (
                            <NtCheckboxCheckedAndDisabled
                                label={t(
                                    'scheduleSurgery.Shipping.ProductCard.TransferComplete'
                                )}
                                batchLocations={batchLocations}
                                productKey={product.productKey}
                                nonTissueProduct={product}
                                isShowCheckBox={isShowCheckBox}
                                isMessageDisplay={isMessageDisplay}
                                isShowLabelEmpty={isShowLabelEmpty}
                                isShowSetLocation={isShowSetLocation}
                            />
                        )
                    ) : (
                        <NtCheckboxDropdownWithErroText
                            checked={checked}
                            checkBoxClick={() => {
                                try {
                                    if (!inventoryShipping)
                                        handleLocationChange(
                                            product.productKey,
                                            !product.shippingRequirement
                                        );
                                } catch (error) {
                                    logErrorToConsole(error);
                                }
                            }}
                            inventoryShipping={inventoryShipping}
                            batchLocations={batchLocations}
                            selectedBatchLocationTemplate={
                                selectedBatchLocationTemplate
                            }
                            allocatedData={allocatedData}
                            batchLocationTemplate={batchLocationTemplate}
                            selectedLocation={selectedLocation}
                            handleLocationChange={handleLocationChange}
                            nonTissueProduct={product}
                            isShowCheckBox={isShowCheckBox}
                            isMessageDisplay={isMessageDisplay}
                            isShowLabelEmpty={isShowLabelEmpty}
                            isShowSetLocation={isShowSetLocation}
                            isShowDropDown={isShowDropDown}
                        />
                    )}
                </>
            ) : (
                <>
                    {countryISOCode !== US_COUNTRY_CODE && product?.isReservationSet ? (
                        <Select
                            panelClassName="batch-dropdown-panel"
                            id="common-index-batchDropDown-batchSelection"
                            width={
                                window.innerWidth > sizes.mobileDevice
                                    ? '89%'
                                    : '100%'
                            }
                            marginLeft={
                                window.innerWidth > sizes.mobileDevice
                                    ? '10px'
                                    : '8px'
                            }
                            placeholder={
                                t('common.batchSelection')
                            }
                            right={'1.9rem'}
                            options={
                                batchLocations?.batchAllocations
                                    ?.filter((batch) =>
                                        countryISOCode !== US_COUNTRY_CODE
                                            ? true
                                            : batch.isParked
                                    )?.sort((a, b) => {
                                        if (a.id === '' || b.id === '') {
                                            return 0;
                                        }
                                        return a.id - b.id;
                                    })
                                    .map((batch) => {
                                        return {
                                            ...batch,
                                            currentLocationFormatted:
                                                batch?.currentLocation
                                                    ? `${t(
                                                          'scheduleSurgery.Shipping.BatchLocationCard.batchLabel'
                                                      )} ${batch.id}: ${
                                                          batch.isBatchAlreadyAllocated
                                                              ? batch
                                                                    .batchAlreadyAllocated[0]
                                                                    ?.accountName
                                                              : batch.currentLocation
                                                      } `
                                                    : `${t(
                                                          'scheduleSurgery.Shipping.BatchLocationCard.batchLabel'
                                                      )} ${batch.id}`,
                                        };
                                    }) || []
                            }
                            optionLabel={'reservationBatch'}
                            valueTemplate={selectedBatchLocationTemplate}
                            optionValue="id"
                            itemTemplate={batchLocationTemplate}
                            value={product?.reservationBatchId}
                            onChange={handleReservationBatch}
                            emptyMessage={t(
                                'scheduleSurgery.Shipping.ProductCard.NoBatchAvailable'
                            )}
                            labelColor="#202124"
                            borderRadius="6px"
                            selectedLabelFontSize="14px"
                            hideClear
                            scrollHeight={
                                window.innerWidth <= sizes.mobileDevice
                                    ? '135px'
                                    : '200px'
                            }
                            height = {'30px'}
                        />
                    ) : (
                        product?.isSet &&
                        (checked || checkAll) && (
                            <Select
                                panelClassName="batch-dropdown-panel"
                                id="common-index-batchDropDown-batchLabel"
                                width={
                                    window.innerWidth > sizes.mobileDevice
                                        ? '89%'
                                        : '100%'
                                }
                                marginLeft={
                                    window.innerWidth > sizes.mobileDevice
                                        ? '10px'
                                        : '8px'
                                }
                                placeholder={
                                    t('common.batchSelection')
                                }
                                right={'1.9rem'}
                                options={
                                    batchLocations?.batchAllocations
                                        ?.filter((batch) =>
                                            countryISOCode !== US_COUNTRY_CODE
                                                ? true
                                                : batch.isParked ||
                                                  batch.isRemoveSelection
                                        )
                                        ?.sort((a, b) => {
                                            if (a.id === '' || b.id === '') {
                                                return 0;
                                            }
                                            return a.id - b.id;
                                        })
                                        .map((batch) => {
                                            return {
                                                ...batch,
                                                currentLocationFormatted:
                                                    batch?.currentLocation
                                                        ? `${t(
                                                              'scheduleSurgery.Shipping.BatchLocationCard.batchLabel'
                                                          )} ${batch.id}: ${
                                                              batch.isBatchAlreadyAllocated
                                                                  ? batch
                                                                        .batchAlreadyAllocated[0]
                                                                        ?.accountName
                                                                  : batch.currentLocation
                                                          } `
                                                        : `${t(
                                                              'scheduleSurgery.Shipping.BatchLocationCard.batchLabel'
                                                          )} ${batch.id}`,
                                            };
                                        }) || []
                                }
                                optionLabel="currentLocation"
                                valueTemplate={selectedBatchLocationTemplate}
                                optionValue="id"
                                itemTemplate={batchLocationTemplate}
                                value={product?.batchId}
                                onChange={handleLocationChange}
                                emptyMessage={t(
                                    'scheduleSurgery.Shipping.ProductCard.NoBatchAvailable'
                                )}
                                labelColor="#202124"
                                borderRadius="6px"
                                selectedLabelFontSize="14px"
                                hideClear
                                scrollHeight={
                                    window.innerWidth <= sizes.mobileDevice
                                        ? '135px'
                                        : '200px'
                                }
                                height = {'30px'}
                            />
                        )
                    )}
                </>
            )}
        </>
    );
};

export default BatchDropDown;